<script>
import { mapGetters } from 'vuex'
import UserUpcomingReservations from '../components/UserUpcomingReservations.vue'
import SideMenu from '../components/SideMenu.vue'

export default {
    name: 'Account',
    components: { UserUpcomingReservations, SideMenu },
    computed: {
        ...mapGetters(['userResource', 'isApexClub']),
        apexClubName() {
            return this.$appConfig('APEX_CLUB_NAME', 'Apex Club')
        },
        accountGroups() {
            return [
                {
                    items: this.navItems.map((item) => ({
                        key: item.name,
                        label: item.label,
                        icon: item.icon,
                        to: { name: item.route },
                    })),
                },
            ]
        },
        navItems() {
            const items = [
                { name: 'profile', route: 'accountProfile', icon: 'person', label: 'Profile' },
                { name: 'payment', route: 'accountPayment', icon: 'credit-card', label: 'Payment' },
                { name: 'transactions', route: 'accountTransactions', icon: 'receipt', label: 'Transactions' },
                { name: 'reservations', route: 'accountReservations', icon: 'calendar-check', label: 'Reservations' },
                { name: 'waivers', route: 'accountWaivers', icon: 'file-earmark-text', label: 'Waivers' },
                { name: 'notifs', route: 'accountNotifications', icon: 'bell', label: 'Notifications' },
                { name: 'laps', route: 'accountLapTimes', icon: 'stopwatch', label: 'Lap Times' },
                { name: 'presets', route: 'racesPresets', icon: 'collection-play', label: 'Race Presets' },
            ]

            if (this.isApexClub) {
                items.splice(2, 0, {
                    name: 'subscription',
                    route: 'accountSubscription',
                    icon: 'patch-check',
                    label: 'Subscription',
                })
            }

            return items
        },
    },
    provide() {
        return { account: this }
    },
    data() {
        return {
            upcomingReservationsData: null,
        }
    },
}
</script>

<template>
    <div class="sa-page">
        <header-image kicker="Votre compte">
            <h1>{{ userResource }}</h1>
        </header-image>

        <div class="sa-page__inner">
            <user-upcoming-reservations poll-seconds="5" @reservations="(d) => (upcomingReservationsData = d)" />

            <div v-if="$appConfigBool('APEX_CLUB_ENABLED', true) && !isApexClub" class="sa-note sa-note--live mb-4">
                L'adhésion à {{ apexClubName }} vous permet d'économiser 20 % sur chaque réservation de simulateur, et vous donne accès aux invitations aux événements des membres et aux soirées de course gratuites.
                <router-link :to="{ name: 'subscription' }">Découvrir {{ apexClubName }}</router-link>
            </div>

            <div class="sa-railpage mt-4" style="--sa-rail-w: 220px">
                <side-menu :groups="accountGroups" />

                <div class="sa-railpage__body">
                    <router-view />
                </div>
            </div>
        </div>
    </div>
</template>
